import axios from 'axios'

export default {
    namespaced: true,
    actions: {
        FetchWithdrawnApplicationByEnrolmentID({ }, eid) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/withdrawn-application/fetch/enrolmentid/${eid}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data.payload);
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchWithdrawnApplicationByEnrolmentID: ${error.message}`));
            });
        },
        UpsertWithdrawnApplication({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/withdrawn-application/upsert`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`UpsertWithdrawnApplication: ${error.message}`));
            });
        },
    },
}
